define('controllers/myreport/myreport-appmarket.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('appMarketReport', ['$scope', '$q', 'OpenApp', 'OpenOther', "$filter", 'reportUtil', 'auiDialog',
        function ($scope, $q, OpenApp, OpenOther, $filter, reportUtil, auiDialog) {
            /* 1. 局部变量声明 */
            /* 2. $scope变量声明 */

            $scope.tabType = {type: 'download'};
            $scope.hadInit = false;
            var Model = $scope.Model = {
                tabType: 'download',
                downloadMagicType: 'line',
                addAdkpMagicType: 'line',
                payInAppMagicTypeM: 'line',
                payInAppMagicTypeN: 'line',
                magicTypeNonInstallApp: 'line',
                queryDownload: {
                    // 这里可以什么都不写，直接用默认值
                    appId: '-1',
                    appName: '-1',
                    //【产品下拉框】【默认值】-1
                    appListQueryMethod: $scope.$parent.initAppList('appmarket', 4),
                    regionShow: [0, 7, 5, 6],           //【展示哪些时间段】【默认值】[0,4,5,6]【枚举】0:自定义 1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    regionType: 7,                   //【时间段】【默认值】0 【枚举】0:自定义1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    startTime: new Date(),           //【开始时间】【默认值】今天
                    endTime: new Date(),             //【结束时间】【默认值】今天
                    timeQuantum: 31,                 //【允许的时间跨度】默认值是不限制
                    queryMethod: queryDownloadList, //【查询方法】必填。点击查询调用的方法
                    downloadMethod: downloadDownloadList, //【下载方法】非必填。点击下载调用的方法。 如果不填，表示不展示下载按钮，
                    onload: init
                },
                queryAddAdkp: {
                    // 这里可以什么都不写，直接用默认值
                    appId: '-3',
                    appName: '-1',
                    appListQueryMethod: $scope.$parent.initAppList('appmarket', 4),
                    regionShow: [0, 7, 5, 6],           //【展示哪些时间段】【默认值】[0,4,5,6]【枚举】0:自定义 1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    regionType: 7,                   //【时间段】【默认值】0 【枚举】0:自定义1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    startTime: new Date(),           //【开始时间】【默认值】今天
                    endTime: new Date(),             //【结束时间】【默认值】今天
                    timeQuantum: 31,                 //【允许的时间跨度】默认值是不限制
                    queryMethod: queryAddAdkpList, //【查询方法】必填。点击查询调用的方法
                    downloadMethod: addAdkpDownloadList//【下载方法】非必填。点击下载调用的方法。 如果不填，表示不展示下载按钮，
                },
                queryPayInApp: {
                    // 这里可以什么都不写，直接用默认值
                    appId: '-3',
                    appName: '-1',
                    appListQueryMethod: $scope.$parent.initAppList('appmarket', 4),
                    regionShow: [0, 7, 5, 6],           //【展示哪些时间段】【默认值】[0,4,5,6]【枚举】0:自定义 1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    regionType: 7,                   //【时间段】【默认值】0 【枚举】0:自定义1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    startTime: new Date(),           //【开始时间】【默认值】今天
                    endTime: new Date(),             //【结束时间】【默认值】今天
                    timeQuantum: 31,                 //【允许的时间跨度】默认值是不限制
                    queryMethod: queryPayInAppList, //【查询方法】必填。点击查询调用的方法
                    downloadMethod: payInAppDownloadList //【下载方法】非必填。点击下载调用的方法。 如果不填，表示不展示下载按钮，
                },
                queryAppPay: {
                    // 传递哪些筛选条件，哪些筛选条件就展示。全集如下
                    appId: '-1',
                    appName: '-1',//【产品下拉框】【默认值】-1
                    appListQueryMethod: $scope.$parent.initAppList('appmarket', 4),
                    regionShow: [0, 7, 5, 6],           //【展示哪些时间段】【默认值】[0,4,5,6]【枚举】0:自定义 1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    regionType: 7,                   //【时间段】【默认值】0 【枚举】0:自定义1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    startTime: new Date(),           //【开始时间】【默认值】今天
                    endTime: new Date(),             //【结束时间】【默认值】今天
                    timeQuantum: 31,                 //【允许的时间跨度】默认值是不限制
                    queryType: 1,                    //【时间类型】【默认值】1【枚举】1:购买时间2:退款时间
                    tradeId: '',                     //【订单编号】【默认值】空
                    tradeStatus: -1,                 //【订单状态】【默认值】-1【枚举】-1:全部状态1:预扣2:确认扣除3:预扣解除4:直接扣除成功5:直接扣除失败6:退款成功
                    queryMethod: queryAppPayListBefore, //【查询方法】必填。点击查询调用的方法
                    downloadMethod: downloadAppPayList //【下载方法】非必填。点击下载调用的方法。 如果不填，表示不展示下载按钮，
                },
                queryNonInstallApp: {
                    appId: '-19',                  //【产品下拉框】【默认值】-1
                    appName: '-1',
                    runEntry: {
                        entryId: '-1',
                        entryName: '全部'
                    },
                    appListQueryMethod: getNonInstallApplist('nonInstallApp', [19]),
                    regionShow: [5, 6, 7],       //【展示哪些时间段】【默认值】[0,4,5,6]【枚举】0:自定义1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    regionType: 7,               //【时间段】【默认值】0 【枚举】0:自定义1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    startTime: new Date(),       //【开始时间】【默认值】今天
                    endTime: new Date(),         //【结束时间】【默认值】今天
                    timeQuantum: 31,              //【允许的时间跨度】默认值是不限制
                    queryMethod: queryNonInstallAppList,
                    downloadMethod: downloadNonInstallAppList,
                    onload: init
                },
                paginationDownload: {
                    currentPage: 1,
                    itemsPerPage: 10,
                    itemsPerPageBackUp: 10,
                    totalCount: 0,
                    noItems: "No products",
                    pagesLength: 5,
                    onChange: pageChangeDownload
                },
                paginationAddAdkp: {
                    currentPage: 1,
                    itemsPerPage: 10,
                    itemsPerPageBackUp: 10,
                    totalCount: 0,
                    noItems: "No products",
                    pagesLength: 5,
                    onChange: pageChangeAddAdkp
                },
                paginationPayInApp: {
                    currentPage: 1,
                    itemsPerPage: 10,
                    itemsPerPageBackUp: 10,
                    totalCount: 0,
                    noItems: "No products",
                    pagesLength: 5,
                    onChange: pageChangePayInApp
                },
                paginationAppPay: {
                    currentPage: 1,
                    itemsPerPage: 10,
                    itemsPerPageBackUp: 10,
                    totalCount: 0,
                    noItems: "No products",
                    pagesLength: 5,
                    onChange: queryAppPayList
                },
                paginationNonInstallApp: {
                    currentPage: 1,
                    itemsPerPage: 10,
                    itemsPerPageBackUp: 10,
                    totalCount: 0,
                    noItems: "No products",
                    pagesLength: 5,
                    onChange: pageChangeNonInstallApp
                },
                downloadList: null,
                addAdkpList: null,
                payInAppList: null,
                appPayList: null,
                queryNonInstallAppList: [],
                queryNonInstallForTable: null,
                downloadCharts: {
                    id: "myreport_appmarket_download",
                    width: "",//非必填参数
                    height: "400",
                    status: 1,// 1: 初始化 2:加载完成
                    type: $scope.tabType
                },
                addAdkpCharts: {
                    id: "myreport_appmarket_addAdkp",
                    width: "",//非必填参数
                    height: "400",
                    status: 1,// 1: 初始化 2:加载完成
                    type: $scope.tabType
                },
                payInAppChartsM: {
                    id: "myreport_appmarket_payInAppM",
                    width: "",//非必填参数
                    height: "400",
                    status: 1,// 1: 初始化 2:加载完成
                    type: $scope.tabType
                },
                payInAppChartsN: {
                    id: "myreport_appmarket_payInAppN",
                    width: "",//非必填参数
                    height: "400",
                    status: 1,// 1: 初始化 2:加载完成
                    type: $scope.tabType
                },
                nonInstallAppCharts: {
                    id: "myreport_nonInstall_App",
                    width: "",
                    height: "400",
                    status: 1,
                    type: "nonInstallApp"
                },
                payType: mainCons.reportAll.payType_Old,
                tradeStatus: mainCons.reportAll.tradeStatus
            };
            Model.variableOfScope = 'variable of scope';
            /* 3. $scope函数挂载 */
            $scope.changeTabType = changeTabType;
            $scope.queryDownloadList = queryDownloadList;
            $scope.downloadDownloadList = downloadDownloadList;

            $scope.queryPayInAppList = queryPayInAppList;
            $scope.addAdkpDownloadList = addAdkpDownloadList;

            $scope.queryPayInAppList = queryPayInAppList;
            $scope.payInAppDownloadList = payInAppDownloadList;
            $scope.entryIdIsAll = true;

            $scope.queryAppPayListBefore = queryAppPayListBefore;
            $scope.queryAppPayList = queryAppPayList;
            $scope.downloadAppPayList = downloadAppPayList;

            /* 4. 初始化函数声明与执行 */
            function init() {
                if (!$scope.hadInit) {
                    changeTabType();
                }
            }

            /* 5. 函数声明 */
            function changeTabType(type) {
                if (type) {
                    $scope.tabType.type = type;
                }
                switch ($scope.tabType.type) {
                    case 'download':
                        if (Model.downloadList == null) {
                            queryDownloadList();
                        }
                        break;
                    case 'addAdkp':
                        if (Model.addAdkpList == null) {
                            queryAddAdkpList();
                        }
                        break;
                    case 'payInApp':
                        if (Model.payInAppList == null) {
                            queryPayInAppList();
                        }
                        break;
                    case 'appPay':
                        if (Model.appPayList == null) {
                            queryAppPayList();
                        }
                        break;
                    case 'nonInstallApp':
                        if (Model.nonInstallApp == null) {
                            queryNonInstallAppList();
                        }
                        break;
                }
            }

            // 获取应用列表
            function getNonInstallApplist(pageType, prodTypeList) {
                return function () {
                    var appList = appList || [];
                    var defer = $q.defer();
                    var request = {
                        serviceItem: -1,
                        prodTypeList: prodTypeList
                    };
                    OpenOther.getReportAppList(request).then(function (data) {
                        if (data && data.returnCode == 200) {
                            var appInfoList = [];
                            data.appList.forEach(function (appInfo) {
                                appInfoList.push({
                                    prodID: appInfo.appId,
                                    prodName: appInfo.appName,
                                    packageName: appInfo.packageName
                                });
                            });
                            appList = appList.concat(appInfoList);

                        }
                    }).catch(function (data) {
                    }).finally(function () {
                        defer.resolve(appList);
                    });
                    return defer.promise;
                }
            }

            /* 5. 函数声明 */
            function queryDownloadList() {
                // 获取packageName
                if (Model.queryDownload.appId != '-1') {
                    angular.forEach($scope.$parent.marketAppList, function (appInfo) {
                        if (appInfo.prodID == Model.queryDownload.appId) {
                            Model.queryDownload.packageName = appInfo.packageName;
                        }
                    });
                }
                else {
                    Model.queryDownload.packageName = '-1';
                }
                var request = {
                    pageSize: 1,
                    pageNum: 0,
                    type: 1
                };
                if (Model.queryDownload.regionShow) {
                    return;
                } else {
                    $scope.hadInit = true;
                }
                AUI.BaseJSUtil.mergeJSON(Model.queryDownload, request);

                if (!$scope.$parent.checkDate(request)) {
                    auiDialog.fail("时间区间选择错误", "查询时间不得为空");
                } else {
                    OpenOther.getReportBI({reportType: 'getAppDown', params: request}).then(function (resp) {
                        Model.downloadList = resp;
                        Model.paginationDownload.totalCount = Model.downloadList && Model.downloadList.result ? Model.downloadList.result.length : 0;
                        Model.paginationDownload.currentPage = 1;
                        Model.paginationDownload.itemsPerPage = Model.paginationDownload.itemsPerPageBackUp;
                        pageChangeDownload();
                        getEchartConfig();
                    });
                }
            }

            function downloadDownloadList() {
                // 获取packageName
                if (Model.queryDownload.appId != '-1') {
                    angular.forEach($scope.$parent.marketAppList, function (appInfo) {
                        if (appInfo.prodID == Model.queryDownload.appId) {
                            Model.queryDownload.packageName = appInfo.packageName;
                        }
                    });
                }
                else {
                    Model.queryDownload.packageName = '-1'
                }
                var param = {
                    startTime: Model.queryDownload.startTime,
                    endTime: Model.queryDownload.endTime,
                    appId: Model.queryDownload.appId,
                    packageName: Model.queryDownload.packageName,
                    type: 3
                };
                if (!$scope.$parent.checkDate(param)) {
                    auiDialog.fail("时间区间选择错误", "查询时间不得为空");
                    return;
                }
                $scope.$parent.downloadReport(OpenOther.exportReport, {
                    reportType: 'getAppDown',
                    params: param
                }, function (resp) {
                    return resp && resp.retCode == 0;
                });
            }


            function queryAddAdkpList() {
                var request = {
                    pageSize: 1,
                    pageNum: 0
                };
                AUI.BaseJSUtil.mergeJSON(Model.queryAddAdkp, request);
                if (!$scope.$parent.checkDate(request)) {
                    auiDialog.fail("时间区间选择错误", "查询时间不得为空");
                } else {
                    OpenOther.getReportBI({
                        reportType: 'getGameNewRetentionReport',
                        params: request
                    }).then(function (resp) {
                        Model.addAdkpList = resp;
                        Model.paginationAddAdkp.totalCount = Model.addAdkpList && Model.addAdkpList.result ? Model.addAdkpList.result.length : 0;
                        Model.paginationAddAdkp.currentPage = 1;
                        Model.paginationAddAdkp.itemsPerPage = Model.paginationAddAdkp.itemsPerPageBackUp;
                        pageChangeAddAdkp();
                        getAddAdkpEchartConfig();
                    });
                }
            }

            function addAdkpDownloadList() {
                var param = {
                    startTime: Model.queryAddAdkp.startTime,
                    endTime: Model.queryAddAdkp.endTime,
                    appId: Model.queryAddAdkp.appId,
                    appName: Model.queryAddAdkp.appName
                };
                if (!$scope.$parent.checkDate(param)) {
                    auiDialog.fail("时间区间选择错误", "查询时间不得为空");
                    return;
                }
                $scope.$parent.downloadReport(OpenOther.exportReport, {
                    reportType: 'getGameNewRetentionReport',
                    params: param
                }, function (resp) {
                    return resp && resp.retCode == 0;
                });
            }

            function queryPayInAppList() {
                var request = {
                    pageSize: 1,
                    pageNum: 0
                };
                AUI.BaseJSUtil.mergeJSON(Model.queryPayInApp, request);
                if (!$scope.$parent.checkDate(request)) {
                    auiDialog.fail("时间区间选择错误", "查询时间不得为空");
                } else {
                    OpenOther.getReportBI({reportType: 'getIAPReport', params: request}).then(function (resp) {
                        Model.payInAppList = resp;
                        Model.paginationPayInApp.totalCount = Model.payInAppList && Model.payInAppList.result ? Model.payInAppList.result.length : 0;
                        Model.paginationPayInApp.currentPage = 1;
                        Model.paginationPayInApp.itemsPerPage = Model.paginationPayInApp.itemsPerPageBackUp;
                        pageChangePayInApp();
                        getPayInAppEchartConfigM();
                        getPayInAppEchartConfigN();
                    });
                }
            }

            function payInAppDownloadList() {
                var param = {
                    startTime: Model.queryPayInApp.startTime,
                    endTime: Model.queryPayInApp.endTime,
                    appId: Model.queryPayInApp.appId,
                    appName: Model.queryPayInApp.appName
                };
                if (!$scope.$parent.checkDate(param)) {
                    auiDialog.fail("时间区间选择错误", "查询时间不得为空");
                    return;
                }
                $scope.$parent.downloadReport(OpenOther.exportReport, {
                    reportType: 'getIAPReport',
                    params: param
                }, function (resp) {
                    return resp && resp.retCode == 0;
                });
            }

            function queryAppPayListBefore() {
                if (Model.paginationAppPay.currentPage == 1) {
                    queryAppPayList();
                } else {
                    Model.paginationAppPay.currentPage = 1;
                    Model.paginationAppPay.itemsPerPage = Model.paginationAppPay.itemsPerPageBackUp;
                }
            }


            /* 5. 函数声明 */
            function queryAppPayList() {
                Model.appPayList = {};
                var request = getParams();
                if (request) {
                    OpenOther.getAppPayDetail(request).then(function (resp) {
                        Model.appPayList = resp;
                        Model.paginationAppPay.totalCount = Model.appPayList.tradeTotalNum;
                    }).catch(function () {
                        Model.appPayList = {};
                        Model.appPayList.tradeDetails = [];
                    })
                }

            }

            function downloadAppPayList() {
                var request = getParams();
                if (request) {
                    $scope.$parent.downloadReport(OpenOther.downloadAppPayDetail, request, function (resp) {
                        return resp && resp.downUrl && resp.password;
                    });
                }

            }

            function getParams() {
                var request = {
                    pageSize: Model.paginationAppPay.itemsPerPage,
                    pageNum: Model.paginationAppPay.currentPage
                };
                AUI.BaseJSUtil.mergeJSON(Model.queryAppPay, request);

                if (!$scope.$parent.checkDate(request)) {
                    auiDialog.fail("时间区间选择错误", "查询时间不得为空");
                    return;
                }

                request.startTime += ' 00:00:00';
                request.endTime += ' 23:59:59';
                if (request.tradeId == '') {
                    delete request.tradeId;
                }
                if (request.tradeStatus == -1) {
                    delete request.tradeStatus;
                }
                if (request.appId == -1) {
                    delete request.appId;
                }
                return request;
            }

            // 查询免安装应用报表
            function queryNonInstallAppList(event) {
                if (!Model.queryNonInstallApp.appId) {
                    pageChangeNonInstallApp();
                    Model.nonInstallAppCharts.options = null;
                    if (event && event.type == 'click') {
                        auiDialog.warn('暂无相关数据');
                    }
                    return;
                }

                // 请求参数
                var request = {
                    //加C适配应用市场的内部应用
                    appId: Model.queryNonInstallApp.appId != '-1' ? 'C' + Model.queryNonInstallApp.appId : '-1',
                    entryId: Model.queryNonInstallApp.runEntry.entryId ? Model.queryNonInstallApp.runEntry.entryId : '-1',
                    startTime: Model.queryNonInstallApp.startTime,
                    endTime: Model.queryNonInstallApp.endTime,
                    pageNum: 1,
                    pageSize: 100000
                };
                if (!$scope.$parent.checkDate(request)) {
                    auiDialog.fail("时间区间选择错误", "查询时间不得为空");
                } else {
                    // 查询免安装应用报表数据
                    OpenOther.getReportBI({reportType: 'getNonInstallApp', params: request}).then(function (resp) {
                        Model.queryNonInstallAppList = resp.result;
                        Model.paginationNonInstallApp.totalCount = resp.total;
                        if (Model.paginationNonInstallApp.totalCount && Model.paginationNonInstallApp.totalCount > 0) {
                            var eChartList = reportUtil.getXYFromBI(Model.queryNonInstallAppList, "date", 1, ['newOpenCnt', 'avgRunTime']);
                            Model.nonInstallAppCharts.options = {
                                legend: {
                                    data: ['新增打开次数', '平均运行时长(秒/次)']
                                },
                                xAxis: [{ // 横坐标
                                    type: 'category', data: eChartList["date"]
                                }],
                                yAxis: [{ // 纵坐标
                                    position: 'left',
                                    type: 'value',
                                    name: '新增打开次数'
                                }, { // 纵坐标
                                    position: 'right',
                                    name: '平均运行时长(秒/次)',
                                    type: 'value',
                                }],
                                series: [{
                                    "name": "新增打开次数",
                                    "type": Model.magicTypeNonInstallApp,
                                    "data": eChartList["newOpenCnt"]
                                }, {
                                    "name": "平均运行时长(秒/次)",
                                    "yAxisIndex": 1,
                                    "type": Model.magicTypeNonInstallApp,
                                    "data": eChartList["avgRunTime"]
                                }]
                            }
                        } else {
                            Model.nonInstallAppCharts.options = null;
                        }
                        $scope.entryIdIsAll = Model.queryNonInstallApp.runEntry.entryId == "-1" ? true : false;
                        Model.paginationNonInstallApp.currentPage = 1;
                        Model.paginationNonInstallApp.itemsPerPage = Model.paginationNonInstallApp.itemsPerPageBackUp;
                        pageChangeNonInstallApp();
                    });
                }
            }

            // 下载免安装应用报表
            function downloadNonInstallAppList() {
                var request = {
                    //加C适配应用市场内部应用
                    appId: Model.queryNonInstallApp.appId ? 'C' + Model.queryNonInstallApp.appId : '-1',
                    appName: Model.queryNonInstallApp.appName,
                    entryId: Model.queryNonInstallApp.runEntry.entryId ? Model.queryNonInstallApp.runEntry.entryId : '-1',
                    startTime: Model.queryNonInstallApp.startTime,
                    endTime: Model.queryNonInstallApp.endTime,
                    pageNum: 1,
                    pageSize: 100000
                };

                if (!$scope.$parent.checkDate(request)) {
                    auiDialog.fail("时间区间选择错误", "查询时间不得为空");
                    return;
                }

                $scope.$parent.downloadReport(OpenOther.exportReport, {
                    reportType: 'getNonInstallApp',
                    params: request
                }, function (resp) {
                    return resp && resp.retCode == 0;
                });
            }

            function getEchartConfig() {
                var result = reportUtil.getXYFromBI(angular.copy(Model.downloadList.result), "time", 1,
                    ["appDownNum", "unExtendUpdateDown", "unNatureUpdateDown", "unUpdateDown", "updateDownNum", "browseDownRatio", "installSuccessRatio"]);
                Model.downloadCharts.options = (result && result['time'] && result['time'].length > 0) ? {
                    legend: {
                        selected: {// 非必填参数
                            '推广非更新下载': false,
                            '自然非更新下载': false,
                            '浏览转化率': false,
                            '安装成功率': false
                        },
                        data: ['日总下载', '更新下载', '非更新下载', '推广非更新下载', '自然非更新下载', '浏览转化率', '安装成功率']
                    },
                    xAxis: [{ // 横坐标
                        type: 'category', data: result["time"],
                        boundaryGap: Model.downloadMagicType != 'line'
                    }],
                    yAxis: [{ // 纵坐标
                        position: 'left',
                        type: 'value',
                        name: '下载数量（次）'
                    }, { // 纵坐标
                        position: 'right',
                        name: '百分率',
                        type: 'value'
                    }],
                    series: [{
                        "name": "日总下载",
                        "type": Model.downloadMagicType,
                        "yAxisIndex": 0,
                        "data": result["appDownNum"]
                    }, {
                        "name": "更新下载",
                        "type": Model.downloadMagicType,
                        "yAxisIndex": 0,
                        "data": result["updateDownNum"]
                    }, {
                        "name": "非更新下载",
                        "type": Model.downloadMagicType,
                        "yAxisIndex": 0,
                        "data": result["unUpdateDown"]
                    }, {
                        "name": "推广非更新下载",
                        "type": Model.downloadMagicType,
                        "yAxisIndex": 0,
                        "data": result["unExtendUpdateDown"]
                    }, {
                        "name": "自然非更新下载",
                        "type": Model.downloadMagicType,
                        "yAxisIndex": 0,
                        "data": result["unNatureUpdateDown"]
                    }, {
                        "name": "浏览转化率",
                        "type": Model.downloadMagicType,
                        "yAxisIndex": 1,
                        "data": result["browseDownRatio"]
                    }, {
                        "name": "安装成功率",
                        "type": Model.downloadMagicType,
                        "yAxisIndex": 1,
                        "data": result["installSuccessRatio"]
                    }]
                } : null;
            }

            function getAddAdkpEchartConfig() {
                var result = reportUtil.getXYFromBI(angular.copy(Model.addAdkpList.result), "time", 1,
                    ["installRegistRatio", "loginUsers", "newUsers", "twoDaysRetentionRatio", "threeDaysRetentionRatio", "sevenDaysRetentionRatio"]);
                Model.addAdkpCharts.options = (result && result['time'] && result['time'].length > 0) ? {
                    legend: {
                        selected: {// 非必填参数
                            '安装注册率': false,
                            '新增注册用户数': false
                        },
                        data: ['安装注册率', '登录用户数', '新增注册用户数', '次日留存率', '三日留存率', '七日留存率']
                    },
                    xAxis: [{ // 横坐标
                        type: 'category', data: result["time"],
                        boundaryGap: Model.addAdkpMagicType != 'line'
                    }],
                    yAxis: [{ // 纵坐标
                        type: 'value',
                        position: 'left',
                        name: '数量（个数）'
                    }, { // 纵坐标
                        type: 'value',
                        position: 'right',
                        name: '百分率'
                    }],
                    series: [{
                        "name": "安装注册率",
                        "type": Model.addAdkpMagicType,
                        "yAxisIndex": 1,
                        "data": result["installRegistRatio"]
                    }, {
                        "name": "登录用户数",
                        "type": Model.addAdkpMagicType,
                        "yAxisIndex": 0,
                        "data": result["loginUsers"]
                    }, {
                        "name": "新增注册用户数",
                        "type": Model.addAdkpMagicType,
                        "yAxisIndex": 0,
                        "data": result["newUsers"]
                    }, {
                        "name": "次日留存率",
                        "type": Model.addAdkpMagicType,
                        "yAxisIndex": 1,
                        "data": result["twoDaysRetentionRatio"]
                    }, {
                        "name": "三日留存率",
                        "type": Model.addAdkpMagicType,
                        "yAxisIndex": 1,
                        "data": result["threeDaysRetentionRatio"]
                    }, {
                        "name": "七日留存率",
                        "type": Model.addAdkpMagicType,
                        "yAxisIndex": 1,
                        "data": result["sevenDaysRetentionRatio"]
                    }]
                } : null;
            }

            function getPayInAppEchartConfigM() {
                var result = reportUtil.getXYFromBI(angular.copy(Model.payInAppList.result), "time", 1,
                    ["payUsers", "payTimes", "newPayUsers", "payInfiltrateRatio"]);
                Model.payInAppChartsM.options = (result && result['time'] && result['time'].length > 0) ? {
                    legend: {
                        selected: {// 非必填参数
                            '付费笔数': false,
                            '新增付费用户数': false,
                            '付费渗透率': false
                        },
                        data: ['付费用户数', '付费笔数', '新增付费用户数', '付费渗透率']
                    },
                    xAxis: [{ // 横坐标
                        type: 'category', data: result["time"],
                        boundaryGap: Model.payInAppMagicTypeM != 'line'
                    }],
                    yAxis: [{ // 纵坐标
                        position: 'left',
                        type: 'value',
                        name: '数量（个数）'
                    }, { // 纵坐标
                        position: 'right',
                        name: '百分率',
                        type: 'value'
                    }],
                    series: [{
                        "name": "付费用户数",
                        "type": Model.payInAppMagicTypeM,
                        "yAxisIndex": 0,
                        "data": result["payUsers"]
                    }, {
                        "name": "付费笔数",
                        "type": Model.payInAppMagicTypeM,
                        "yAxisIndex": 0,
                        "data": result["payTimes"]
                    }, {
                        "name": "新增付费用户数",
                        "type": Model.payInAppMagicTypeM,
                        "yAxisIndex": 0,
                        "data": result["newPayUsers"]
                    }, {
                        "name": "付费渗透率",
                        "type": Model.payInAppMagicTypeM,
                        "yAxisIndex": 1,
                        "data": result["payInfiltrateRatio"]
                    }]
                } : null;
            }

            function getPayInAppEchartConfigN() {
                var result = reportUtil.getXYFromBI(angular.copy(Model.payInAppList.result), "time", 1,
                    ["payAmount", "arppu", "arpu"]);
                Model.payInAppChartsN.options = (result && result['time'] && result['time'].length > 0) ? {
                    legend: {
                        selected: {// 非必填参数

                        },
                        data: ['付费金额', 'ARPPU', 'ARPU']
                    },
                    xAxis: [{ // 横坐标
                        type: 'category', data: result["time"],
                        boundaryGap: Model.payInAppMagicTypeN != 'line'
                    }],
                    yAxis: [{ // 纵坐标
                        position: 'left',
                        type: 'value',
                        name: '金额（元）'
                    }],
                    series: [{
                        "name": "付费金额",
                        "type": Model.payInAppMagicTypeN,
                        "yAxisIndex": 0,
                        "data": result["payAmount"]
                    }, {
                        "name": "ARPPU",
                        "type": Model.payInAppMagicTypeN,
                        "yAxisIndex": 0,
                        "data": result["arppu"]
                    }, {
                        "name": "ARPU",
                        "type": Model.payInAppMagicTypeN,
                        "yAxisIndex": 0,
                        "data": result["arpu"]
                    }]
                } : null;
            }

            /**
             * 这里做前台分页，不需要重新查询一次接口
             */
            function pageChangeDownload() {
                var result = {};
                $scope.$parent && (result = $scope.$parent.pagination(Model.downloadList.result, Model.paginationDownload, true));
                Model.downloadListForShow = result.listForShow;
            }

            function pageChangeAddAdkp() {
                var result = {};
                $scope.$parent && (result = $scope.$parent.pagination(Model.addAdkpList.result, Model.paginationAddAdkp, true));
                Model.addAdkpListForShow = result.listForShow;
            }

            function pageChangePayInApp() {
                var result = {};
                $scope.$parent && (result = $scope.$parent.pagination(Model.payInAppList.result, Model.paginationPayInApp, true));
                Model.payInAppListForShow = result.listForShow;
            }

            function pageChangeNonInstallApp() {
                var result = {};
                $scope.$parent && (result = $scope.$parent.pagination(Model.queryNonInstallAppList, Model.paginationNonInstallApp));
                if (result.listForShow.length > 0) {
                    result.listForShow = result.listForShow;
                }
                Model.queryNonInstallForTable = result.listForShow;
            }

            function getUC() {
                var list = [{
                    tradeId: 2017170101,// 订单编号
                    orderTime: '2017-01-01',// 下单时间
                    tradeTime: '2017-01-02',// 支付时间
                    appName: '泡泡卡丁车',// 应用名称
                    amount: 259900,//支付金额，单位为分
                    payType: 1,//支付方式
                    tradeStatus: 9,//订单状态
                    refundAmount: 249900,//退款金额，当tradeStatus=1才有值
                    refundTime: '2017-01-05'//退款时间，当tradeStatus=1才有值
                }, {
                    tradeId: 2017170102,// 订单编号
                    orderTime: '2017-01-02',// 下单时间
                    tradeTime: '2017-01-03',// 支付时间
                    appName: '泡泡卡丁车1',// 应用名称
                    amount: 269900,//支付金额，单位为分
                    payType: 2,//支付方式
                    tradeStatus: 2,//订单状态
                    refundAmount: '',//退款金额，当tradeStatus=1才有值
                    refundTime: ''//退款时间，当tradeStatus=1才有值
                }, {
                    tradeId: 2017170101,// 订单编号
                    orderTime: '2017-01-03',// 下单时间
                    tradeTime: '2017-01-04',// 支付时间
                    appName: '泡泡卡丁车2',// 应用名称
                    amount: 279900,//支付金额，单位为分
                    payType: 3,//支付方式
                    tradeStatus: 3,//订单状态
                    refundAmount: '',//退款金额，当tradeStatus=1才有值
                    refundTime: ''//退款时间，当tradeStatus=1才有值
                }, {
                    tradeId: 2017170101,// 订单编号
                    orderTime: '2017-01-04',// 下单时间
                    tradeTime: '2017-01-05',// 支付时间
                    appName: '泡泡卡丁车3',// 应用名称
                    amount: 289900,//支付金额，单位为分
                    payType: 4,//支付方式
                    tradeStatus: 4,//订单状态
                    refundAmount: '',//退款金额，当tradeStatus=1才有值
                    refundTime: ''//退款时间，当tradeStatus=1才有值
                }];
                return {
                    "totalIncome": 2544440,
                    "tradeTotalNum": 25,
                    "tradeDetails": list.slice(0, ~~(Math.random() * 5))
                }
            }

            function getBI() {

                var list = [{
                    "appId": "-1",
                    "appName": "-1",
                    "publisherId": "900086000010001000",
                    "time": "2016-01-03",
                    "appDownNum": "3060",
                    "unExtendUpdateDown": "2510",
                    "unNatureUpdateDown": "1130",
                    "unUpdateDown": "2740",
                    "updateDownNum": "1220"
                }, {
                    "appId": "-1",
                    "appName": "-1",
                    "publisherId": "900086000010001000",
                    "time": "2016-01-02",
                    "appDownNum": "360",
                    "unExtendUpdateDown": "900",
                    "unNatureUpdateDown": "1100",
                    "unUpdateDown": "1600",
                    "updateDownNum": "2400"
                }, {
                    "appId": "-1",
                    "appName": "-1",
                    "publisherId": "900086000010001000",
                    "time": "2016-01-01",
                    "appDownNum": "3006",
                    "unExtendUpdateDown": "1001",
                    "unNatureUpdateDown": "1003",
                    "unUpdateDown": "1504",
                    "updateDownNum": "2002"
                }, {
                    "appId": "-1",
                    "appName": "-1",
                    "publisherId": "900086000010001000",
                    "time": "2016-01-04",
                    "appDownNum": "3406",
                    "unExtendUpdateDown": "1401",
                    "unNatureUpdateDown": "1403",
                    "unUpdateDown": "1904",
                    "updateDownNum": "2402"
                }, {
                    "appId": "-1",
                    "appName": "-1",
                    "publisherId": "900086000010001000",
                    "time": "2016-01-06",
                    "appDownNum": "4006",
                    "unExtendUpdateDown": "2001",
                    "unNatureUpdateDown": "2003",
                    "unUpdateDown": "2504",
                    "updateDownNum": "3002"
                }, {
                    "appId": "-1",
                    "appName": "-1",
                    "publisherId": "900086000010001000",
                    "time": "2016-01-05",
                    "appDownNum": "2006",
                    "unExtendUpdateDown": "1201",
                    "unNatureUpdateDown": "1203",
                    "unUpdateDown": "1204",
                    "updateDownNum": "1602"
                }, {
                    "appId": "-1",
                    "appName": "-1",
                    "publisherId": "900086000010001000",
                    "time": "2016-01-07",
                    "appDownNum": "2006",
                    "unExtendUpdateDown": "1201",
                    "unNatureUpdateDown": "1203",
                    "unUpdateDown": "1204",
                    "updateDownNum": "1602"
                }, {
                    "appId": "-1",
                    "appName": "-1",
                    "publisherId": "900086000010001000",
                    "time": "2016-01-08",
                    "appDownNum": "2006",
                    "unExtendUpdateDown": "1201",
                    "unNatureUpdateDown": "1203",
                    "unUpdateDown": "1204",
                    "updateDownNum": "1602"
                }, {
                    "appId": "-1",
                    "appName": "-1",
                    "publisherId": "900086000010001000",
                    "time": "2016-01-09",
                    "appDownNum": "2006",
                    "unExtendUpdateDown": "1201",
                    "unNatureUpdateDown": "1203",
                    "unUpdateDown": "1204",
                    "updateDownNum": "1602"
                }, {
                    "appId": "-1",
                    "appName": "-1",
                    "publisherId": "900086000010001000",
                    "time": "2016-01-10",
                    "appDownNum": "2006",
                    "unExtendUpdateDown": "1201",
                    "unNatureUpdateDown": "1203",
                    "unUpdateDown": "1204",
                    "updateDownNum": "1602"
                }];

                return {
                    "appId": "-1",
                    "returnCode": 200,
                    "returnDesc": "Query Data Right",
                    "total": 3,
                    "quotas": {},
                    "appDownTotal": "33480", // 总下载
                    "unUpdateDown": "17940",//非更新下载
                    "updateDownNum": "21480",// 更新下载
                    "unExtendUpdateDown": "12610",//推广非更新下载
                    "unNatureUpdateDown": "11270",//自然非更新下载
                    "reportHicloudList": list.slice(0, ~~(Math.random() * 10))
                }
            }
        }]
    );
});
